import { Card } from "./ImageCard";
import { Button } from "react-bootstrap";
import { useImageContainer } from "../../hooks/useImageContainer";
import ImagePreviewModal from "./ImagePreviewModal";
import styles from "../../pages/AddImages/styles.module.sass";

const ImageContainer = ({
  images = [],
  id,
  _id,
  allSelected,
  allDeselected,
  pageLoading,
  setPageLoading,
  isUploading = false,
}) => {
  const {
    isAgent,
    cards,
    showModal,
    rotationVal,
    loading,
    onSubmit,
    rotateLeft,
    rotateRight,
    onSubmitRotate,
    handleDelete,
    handleAdd,
    moveCard,
    openModal,
    closeModal,
  } = useImageContainer({
    images,
    id,
    _id,
    allSelected,
    allDeselected,
    pageLoading,
    setPageLoading,
  });

  const renderCard = (card, index) => {
    return (
      <Card
        key={card.id}
        index={index}
        {...card}
        approved={card.approved}
        moveCard={moveCard}
        handleDelete={() => handleDelete(card.id, index)}
        handleAdd={() => handleAdd(card.id, index)}
        isAgent={isAgent}
        toggleModal={() => openModal({ id: card.id, url: card.url })}
      />
    );
  };

  return (
    <div className="d-flex align-items-center justify-content-center flex-column">
      <div className="mb-3">
        <h3>Vaše slike:</h3>
      </div>
      <div className={styles.imageGrid}>
        {cards.map((card, i) => renderCard(card, i))}
      </div>
      <ImagePreviewModal
        showModal={showModal}
        closeModal={closeModal}
        rotationVal={rotationVal}
        loading={loading}
        rotateLeft={rotateLeft}
        rotateRight={rotateRight}
        onSubmitRotate={onSubmitRotate}
      />
      <Button
        className={`btn btn-primary mt-5 ${styles.action}`}
        onClick={onSubmit}
        disabled={isUploading}
        title={
          isUploading
            ? "Sačekajte da se završi upload i obrada slika"
            : undefined
        }
      >
        {!isAgent ? "Odobri slike" : "Pošalji slike"}
      </Button>
      {isUploading && (
        <div className="mt-2 text-muted text-center" style={{ fontSize: 14 }}>
          Dugme je onemogućeno dok se upload i obrada slika ne završe.
        </div>
      )}
    </div>
  );
};

export default ImageContainer;
